import { __decorate, __metadata } from "tslib";
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsInstance, IsObject, IsOptional, ValidateNested } from 'class-validator';
import { OrderConfigExposeGroup } from '../../order-config/interface';
import { prepTimeCalculationByPriceRule, prepTimeCalculationContext } from '../../order-config/swagger';
import { PatchPrepTimeCalculationContextDto } from './PatchPrepTimeCalculationContextDto';
import { PatchPrepTimeCalculationRulesDto } from './PatchPrepTimeCalculationRulesDto';
export class PatchPrepTimeCalculationConfigDto {
    constructor() {
        this.context = new PatchPrepTimeCalculationContextDto();
    }
}
__decorate([
    ApiPropertyOptional({ type: () => PatchPrepTimeCalculationContextDto, description: 'Order preparation context', example: prepTimeCalculationContext }),
    Type(() => PatchPrepTimeCalculationContextDto),
    ValidateNested({ always: true }),
    IsInstance(PatchPrepTimeCalculationContextDto, { always: true }),
    IsObject({ always: true }),
    IsOptional({ groups: [OrderConfigExposeGroup.PATCH, OrderConfigExposeGroup.CREATE] }),
    Expose({ groups: [OrderConfigExposeGroup.CREATE, OrderConfigExposeGroup.READ, OrderConfigExposeGroup.PATCH] }),
    __metadata("design:type", PatchPrepTimeCalculationContextDto)
], PatchPrepTimeCalculationConfigDto.prototype, "context", void 0);
__decorate([
    ApiPropertyOptional({
        type: () => PatchPrepTimeCalculationRulesDto,
        example: { byPrice: prepTimeCalculationByPriceRule },
        description: 'Prep time calculation rules',
    }),
    Type(() => PatchPrepTimeCalculationRulesDto),
    ValidateNested({ always: true }),
    IsInstance(PatchPrepTimeCalculationRulesDto, { always: true }),
    IsOptional({ always: true }),
    Expose({ groups: [OrderConfigExposeGroup.CREATE, OrderConfigExposeGroup.READ, OrderConfigExposeGroup.PATCH] }),
    __metadata("design:type", PatchPrepTimeCalculationRulesDto)
], PatchPrepTimeCalculationConfigDto.prototype, "rules", void 0);
//# sourceMappingURL=PatchPrepTimeCalculationConfigDto.js.map